









import { Component, Inject, Watch, Mixins } from 'vue-property-decorator';
import { AxiosInstance as ApiInstance } from 'axios';
import { remoteEduService } from '@/services';
import { LoaderMixin } from '@/pages/profile/mixins';
import store from '@/pages/profile/store';
import CalendarModule, { FilterTypeEnum } from '../../calendar';
import { ICalendar, CalendarItems } from './types';
import { eduData } from '@/pages/profile/utils';

@Component({
  components: {
    CalendarModule,
  },
  metaInfo: () => ({
    title: 'Календарь дистанционного образования',
  }),
})
export default class Calendar extends Mixins(LoaderMixin) implements ICalendar {
  @Inject() $api: ApiInstance;

  isRoomsType: boolean = false;
  isLessonsType: boolean = false;
  isTestsType: boolean = false;
  isExaminationType: boolean = false;
  items: CalendarItems = [];

  get id(): string {
    return store.state.id;
  }

  get filteredData(): CalendarItems {
    const {
      isRoomsType,
      isLessonsType,
      isTestsType,
      isExaminationType,
      items,
    } = this;
    let select: Array<string> = [];

    if (isRoomsType) select.push(FilterTypeEnum.ROOMS_TYPE);
    if (isLessonsType) select.push(FilterTypeEnum.LESSONS_TYPE);
    if (isTestsType) select.push(FilterTypeEnum.TESTS_TYPE);
    if (isExaminationType) select.push(FilterTypeEnum.EXAMINATION_TYPE);

    if (!select.length) return items;
    return items.reduce((res, { date, items }) => {
      const filteredItems = items.filter(({ type }) => !select.includes(type));

      if (filteredItems.length) {
        res.push({
          date,
          items: filteredItems,
        });
      }

      return res;
    }, [] as CalendarItems);
  }

  @Watch('id', { immediate: true })
  onChangeChild(id: string): void {
    if (!id) return;
    this.getData();
  }

  // mounted() {
  //   if (!this.id) return;
  //   this.getData();
  // }

  async getData() {
    const { $api, id } = this;

    try {
      this.setStatus('loading');

       const remoteEduRooms = remoteEduService($api).getRemoteEduRooms(id);
      const remoteEduLessons = remoteEduService($api).getRemoteEduLessons(id);
      const remoteEduTests = remoteEduService($api).getRemoteEduTests(id);
      const remoteEduExamination =
        remoteEduService($api).getRemoteEduExaminationList();

      const [rooms ,lessons, tests, examination] = await Promise.all([
        remoteEduRooms,
        remoteEduLessons,
        remoteEduTests,
        remoteEduExamination,
      ]);

      this.items = eduData([
          ...rooms.data,
        ...lessons.data,
        ...tests.data,
        ...examination.data,
      ]);

      this.setStatus('success');
    } catch (err) {
      this.setStatus('error');
    }
  }

  typeSelect(value: string) {
    switch (value) {
      case FilterTypeEnum.ROOMS_TYPE:
        this.isRoomsType = !this.isRoomsType;
        break;
      case FilterTypeEnum.LESSONS_TYPE:
        this.isLessonsType = !this.isLessonsType;
        break;
      case FilterTypeEnum.TESTS_TYPE:
        this.isTestsType = !this.isTestsType;
        break;
      case FilterTypeEnum.EXAMINATION_TYPE:
        this.isExaminationType = !this.isExaminationType;
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/views/calendar/Calendar.vue